// @flow

import type { Process } from '@gandi/cart';
import { useTranslator, mapTags, type TranslatorProps } from '@gandi/translate';

import { SetupPill } from '../SetupPill';

import { useDomainConfiguration } from './hooks';

type Props = {
  process: Process,
};

function getTranslation(
  __: TranslatorProps['__'],
  id: void | string,
  templateName: string,
  process: string,
) {
  switch (true) {
    case !!id || process === 'create':
      return mapTags(__('[[templateName:]] applied'), () => ({
        templateName,
      }));
    case process === 'transfer':
      return __(
        "The domain's nameservers will not be changed during the transfer.",
      );
    default:
      return null;
  }
}

export function DomainConfigurationCellContents({
  process,
}: Props): null | React.MixedElement {
  const { __ } = useTranslator();
  const { templateChangeURL, committed, configuration } =
    useDomainConfiguration(process);

  const payload = configuration?.payload || {};
  const id = payload.template_id || undefined;
  const name = payload.template_name || __('Gandi default configuration');
  const locked = payload.locked || false;
  const label = getTranslation(__, id, name, process);

  if (!label) {
    return null;
  }

  const enabled = !locked && !committed && !!templateChangeURL;

  return (
    <SetupPill to={templateChangeURL} disabled={!enabled}>
      {label}
    </SetupPill>
  );
}
